<div class="loading-screen" *ngIf="loading" fxLayout="column">
  <mat-spinner [diameter]="32"></mat-spinner><br>
  <span class="br-label">{{ message }}</span>
</div>
